var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ranking-board"}},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("巡查上报记录数量")]),_c('dv-scroll-ranking-board',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }